import { UI } from '@Modules/UI';

export default function (value) {
  return UI.thumbnail(value);
}
